.editProfileDialog {
  margin-bottom: 20px;
}

.editProfileHint {
  margin: 10px 0;
  color: var(--textLessContrast);
}